import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import kz from '@angular/common/locales/kk';
import ru from '@angular/common/locales/ru';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TitleStrategy } from '@angular/router';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocalizationPipe } from './pipes';
import { PageTitleLocalizationResolver } from './resolvers';
import { LocalizationService } from './services/localization.service';

registerLocaleData(ru);
registerLocaleData(kz);

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: 'ru',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [TranslateModule],
})
export class LocalizationModule {
  static forRoot(): ModuleWithProviders<LocalizationModule> {
    return {
      ngModule: LocalizationModule,
      providers: [
        TranslateService,
        LocalizationService,
        LocalizationPipe,
        {
          provide: TitleStrategy,
          useClass: PageTitleLocalizationResolver,
        },
      ],
    };
  }
}
